"use strict";
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.RcraInfoFederalWasteGeneratorStatus = exports.RcraInfoLandType = exports.RcraInfoAccessibility = exports.RcraInfoNonNotifier = exports.RcraInfoSourceType = exports.HlrncCode = exports.PretreatmentIndicatorCode = exports.AgencyTypeCode = exports.PermitTypeCode = exports.PermitStatusCode = exports.MajorMinorStatusFlag = exports.FacilityTypeCode = exports.FacilityTypeIndicator = exports.EchoQuarterlyHistory = exports.ThresholdResultJurisdictionType = exports.ThresholdResultType = exports.ThresholdReason = exports.LocalJurisdictionType = exports.FacilityPilotProgramStatus = exports.ContactReportRole = exports.Country = exports.FeatureFlagOverride = exports.CollectionMode = exports.FacilityStatus = exports.StateRegulatoryStatus = exports.FederalRegulatoryStatus = exports.ExtractionStatus = exports.DocumentType = exports.CredentialVerificationStatus = exports.CredentialKind = exports.LobMailStatus = exports.LobMailType = exports.CommunicationFacilityType = exports.CommunicationStatus = exports.CommunicationType = exports.CohortMemberStatus = exports.MultiCohortOverrideReason = exports.CohortStatus = exports.CohortType = exports.WeightOrVolume = exports.UnitType = exports.InternationalFireCodeHazard = exports.OregonHazard = exports.HealthHazard = exports.PhysicalHazard = exports.EhsForm = exports.DensityUnits = exports.StateOfMatter = exports.PureOrMixture = exports.Provider = void 0;
exports.TierIIReportUstStep = exports.StatusType = exports.AssignmentType = exports.TierIIReportFiledBy = exports.TierIIReportCAStep = exports.TierIIReportStep = exports.TierIIReportEncampStatus = exports.TierIIReportOrgStatus = exports.TierIIReportKind = exports.TenantContactType = exports.TaskKind = exports.Frequency = exports.TagIcon = exports.TagType = exports.SignatureStatus = exports.ReviewerStatus = exports.SubmissionDocumentType = exports.DocumentSource = exports.SubmissionSource = exports.SubmissionEncampStatus = exports.SubmissionMethod = exports.SubmissionType = exports.SignatureType = exports.ReviewMode = exports.RequirementStatus = exports.SubmissionStatus = exports.Temperature = exports.Pressure = exports.StorageQuadrant = exports.InsideOutside = exports.SnapshotType = exports.Permission = exports.ChemicalDbRequirement = exports.PortalType = exports.TankOwnerType = exports.ReconciliationStatus = exports.PaymentMethod = exports.PaymentStatus = exports.OneSchemaImportProcessingMethod = exports.OneSchemaImportStatus = exports.LockType = exports.JobRunsOn = exports.WebAutomationCollectEvidenceOfCompletionActions = exports.WebAutomationAction = exports.JobStatus = exports.JobTask = exports.WasteManifestIngestSource = exports.WasteManifestSource = exports.RcraInfoOwnerOperatorIndicator = exports.RcraInfoDataOrigin = void 0;
exports.ProgramArea = exports.WorkflowManagerConfigType = exports.WorkflowStatus = exports.WorkflowType = exports.ActivityUserInputType = exports.Tier2SubmitValidationStatus = exports.ActivityStatus = exports.ExecutionPlanType = exports.ActivityType = exports.WasteClassification = exports.StateWasteClassification = exports.WasteClassificationLegacy = exports.EManifestWasteUnit = exports.UserStatus = exports.UserType = void 0;
exports.Provider = {
    OPENAI: 'OPENAI',
    ANTHROPIC: 'ANTHROPIC'
};
exports.PureOrMixture = {
    PURE: 'PURE',
    MIXTURE: 'MIXTURE'
};
exports.StateOfMatter = {
    SOLID: 'SOLID',
    LIQUID: 'LIQUID',
    GAS: 'GAS'
};
exports.DensityUnits = {
    POUNDS_PER_CUBIC_FOOT: 'POUNDS_PER_CUBIC_FOOT',
    POUNDS_PER_GALLON: 'POUNDS_PER_GALLON',
    POUNDS_PER_LITER: 'POUNDS_PER_LITER',
    POUNDS_PER_BARREL: 'POUNDS_PER_BARREL',
    KILOGRAMS_PER_GALLON: 'KILOGRAMS_PER_GALLON',
    KILOGRAMS_PER_LITER: 'KILOGRAMS_PER_LITER',
    KILOGRAMS_PER_CUBIC_FOOT: 'KILOGRAMS_PER_CUBIC_FOOT',
    KILOGRAMS_PER_BARREL: 'KILOGRAMS_PER_BARREL',
    TONS_PER_GALLON: 'TONS_PER_GALLON',
    TONS_PER_LITER: 'TONS_PER_LITER',
    TONS_PER_CUBIC_FOOT: 'TONS_PER_CUBIC_FOOT',
    TONS_PER_BARREL: 'TONS_PER_BARREL',
    METRIC_TONS_PER_GALLON: 'METRIC_TONS_PER_GALLON',
    METRIC_TONS_PER_LITER: 'METRIC_TONS_PER_LITER',
    METRIC_TONS_PER_CUBIC_FOOT: 'METRIC_TONS_PER_CUBIC_FOOT',
    METRIC_TONS_PER_BARREL: 'METRIC_TONS_PER_BARREL'
};
exports.EhsForm = {
    MOLTEN: 'MOLTEN',
    SOLUTION: 'SOLUTION',
    SOLID_PARTICLE_SIZE_LESS_THAN_100_MICRON: 'SOLID_PARTICLE_SIZE_LESS_THAN_100_MICRON',
    NONE: 'NONE'
};
exports.PhysicalHazard = {
    EXPLOSIVE: 'EXPLOSIVE',
    FLAMMABLE: 'FLAMMABLE',
    OXIDIZER: 'OXIDIZER',
    SELF_REACTIVE: 'SELF_REACTIVE',
    PYROPHORIC_SOLID_OR_LIQUID: 'PYROPHORIC_SOLID_OR_LIQUID',
    PYROPHORIC_GAS: 'PYROPHORIC_GAS',
    SELF_HEATING: 'SELF_HEATING',
    ORGANIC_PEROXIDE: 'ORGANIC_PEROXIDE',
    CORROSIVE_TO_METAL: 'CORROSIVE_TO_METAL',
    COMPRESSED_GAS: 'COMPRESSED_GAS',
    FLAMMABLE_WITH_WATER: 'FLAMMABLE_WITH_WATER',
    COMBUSTIBLE_DUST: 'COMBUSTIBLE_DUST',
    UNCLASSIFIED_PHYSICAL_HAZARD: 'UNCLASSIFIED_PHYSICAL_HAZARD'
};
exports.HealthHazard = {
    ACUTE_TOXICITY: 'ACUTE_TOXICITY',
    SKIN_IRRITANT: 'SKIN_IRRITANT',
    EYE_IRRITANT: 'EYE_IRRITANT',
    CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION: 'CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION',
    GERM_CELL_MUTAGENIC: 'GERM_CELL_MUTAGENIC',
    CARCINOGENIC: 'CARCINOGENIC',
    REPRODUCTIVE_TOXICITY: 'REPRODUCTIVE_TOXICITY',
    SPECIFIC_TARGET_ORGAN_TOXICITY: 'SPECIFIC_TARGET_ORGAN_TOXICITY',
    ASPIRATION_HAZARD: 'ASPIRATION_HAZARD',
    SIMPLE_ASPHYXIANT: 'SIMPLE_ASPHYXIANT',
    HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH: 'HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH'
};
exports.OregonHazard = {
    RADIOACTIVE: 'RADIOACTIVE',
    POISONOUS_GAS: 'POISONOUS_GAS',
    POISONOUS_MATERIAL: 'POISONOUS_MATERIAL',
    INFECTIOUS_OR_ETIOLOGIC: 'INFECTIOUS_OR_ETIOLOGIC'
};
exports.InternationalFireCodeHazard = {
    COMBUSTIBLE: 'COMBUSTIBLE',
    CORROSIVE: 'CORROSIVE',
    FLAMMABLE: 'FLAMMABLE',
    INERT: 'INERT',
    OXIDIZING: 'OXIDIZING',
    RADIOACTIVE: 'RADIOACTIVE',
    UNSTABLE: 'UNSTABLE',
    EXPLOSIVE: 'EXPLOSIVE',
    HIGHLY_TOXIC: 'HIGHLY_TOXIC',
    ORGANIC_PEROXIDES: 'ORGANIC_PEROXIDES',
    PYROPHORIC: 'PYROPHORIC',
    TOXIC: 'TOXIC',
    WATER_REACTIVE: 'WATER_REACTIVE'
};
exports.UnitType = {
    POUNDS: 'POUNDS',
    GALLONS: 'GALLONS',
    CUBIC_FEET: 'CUBIC_FEET',
    TONS: 'TONS',
    KILOGRAMS: 'KILOGRAMS',
    METRIC_TONS: 'METRIC_TONS',
    LITERS: 'LITERS',
    BARRELS: 'BARRELS'
};
exports.WeightOrVolume = {
    WEIGHT: 'WEIGHT',
    VOLUME: 'VOLUME'
};
exports.CohortType = {
    FIRE_DEPARTMENT: 'FIRE_DEPARTMENT',
    LEPC: 'LEPC',
    CREDENTIAL: 'CREDENTIAL',
    ALTERNATE_ID: 'ALTERNATE_ID',
    STATE: 'STATE'
};
exports.CohortStatus = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
};
exports.MultiCohortOverrideReason = {
    STRANDED_MEMBER_RECOVERY: 'STRANDED_MEMBER_RECOVERY'
};
exports.CohortMemberStatus = {
    UNKNOWN: 'UNKNOWN',
    NOT_PARTICIPATING: 'NOT_PARTICIPATING',
    NOT_READY: 'NOT_READY',
    READY: 'READY'
};
exports.CommunicationType = {
    CERTIFIED_MAIL: 'CERTIFIED_MAIL',
    FIRST_CLASS_MAIL: 'FIRST_CLASS_MAIL',
    CHECK: 'CHECK',
    EMAIL: 'EMAIL'
};
exports.CommunicationStatus = {
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    SENT_TO_MAIL_CLIENT: 'SENT_TO_MAIL_CLIENT',
    SENT_TO_EMAIL_CLIENT: 'SENT_TO_EMAIL_CLIENT',
    ERROR: 'ERROR'
};
exports.CommunicationFacilityType = {
    OVER_311_THRESHOLD_NOTIFICATION: 'OVER_311_THRESHOLD_NOTIFICATION',
    OVER_302_THRESHOLD_NOTIFICATION: 'OVER_302_THRESHOLD_NOTIFICATION'
};
exports.LobMailType = {
    CHECK: 'CHECK',
    LETTER: 'LETTER'
};
exports.LobMailStatus = {
    MAILED: 'MAILED',
    IN_TRANSIT: 'IN_TRANSIT',
    IN_LOCAL_AREA: 'IN_LOCAL_AREA',
    PROCESSED_FOR_DELIVERY: 'PROCESSED_FOR_DELIVERY',
    DELIVERED: 'DELIVERED',
    RE_ROUTED: 'RE_ROUTED',
    RETURNED_TO_SENDER: 'RETURNED_TO_SENDER',
    INTERNATIONAL_EXIT: 'INTERNATIONAL_EXIT',
    ISSUE: 'ISSUE',
    PICKUP_AVAILABLE: 'PICKUP_AVAILABLE'
};
exports.CredentialKind = {
    RCRA_COUNTY: 'RCRA_COUNTY',
    RCRA_STATE: 'RCRA_STATE',
    RCRA_FEDERAL: 'RCRA_FEDERAL',
    RCRA_PAYMENT: 'RCRA_PAYMENT',
    TIERII: 'TIERII',
    LEPC: 'LEPC'
};
exports.CredentialVerificationStatus = {
    NOT_ATTEMPTED: 'NOT_ATTEMPTED',
    CURRENTLY_VERIFYING: 'CURRENTLY_VERIFYING',
    GOOD: 'GOOD',
    INVALID_ACCESSID_OR_PASSWORD: 'INVALID_ACCESSID_OR_PASSWORD',
    BAD_USERNAME: 'BAD_USERNAME',
    BAD_PASSWORD: 'BAD_PASSWORD',
    BAD_SECURITY_QUESTION_ANSWER: 'BAD_SECURITY_QUESTION_ANSWER',
    EXPIRED_PASSWORD: 'EXPIRED_PASSWORD',
    IN_USE: 'IN_USE',
    REQUIRES_NEW_PASSWORD: 'REQUIRES_NEW_PASSWORD',
    LOCKED: 'LOCKED',
    UNKNOWN_NON_VERIFIABLE: 'UNKNOWN_NON_VERIFIABLE',
    UNKNOWN_ERROR_NEEDS_HUMAN: 'UNKNOWN_ERROR_NEEDS_HUMAN',
    FAILED_ONE_TIME_PASSWORD: 'FAILED_ONE_TIME_PASSWORD'
};
exports.DocumentType = {
    ASTDocumentation: 'ASTDocumentation',
    Certification: 'Certification',
    Check: 'Check',
    CoverLetter: 'CoverLetter',
    DikeDescription: 'DikeDescription',
    EmergencyResponsePlan: 'EmergencyResponsePlan',
    EPCRA302: 'EPCRA302',
    EPCRA304: 'EPCRA304',
    EPCRA311: 'EPCRA311',
    EPCRA312: 'EPCRA312',
    EPCRA313: 'EPCRA313',
    FeeCalculation: 'FeeCalculation',
    Fees: 'Fees',
    Form: 'Form',
    HazardousMaterialsContingencyPlanOrQuickGuide: 'HazardousMaterialsContingencyPlanOrQuickGuide',
    HazardousMaterialsInventoryStatement: 'HazardousMaterialsInventoryStatement',
    HazardousMaterialsManagementPlan: 'HazardousMaterialsManagementPlan',
    HazardousWasteAnnualReport: 'HazardousWasteAnnualReport',
    HazardousWasteBiennialReport: 'HazardousWasteBiennialReport',
    HazardousWasteContingencyPlan: 'HazardousWasteContingencyPlan',
    HazardousWasteFeesReceipts: 'HazardousWasteFeesReceipts',
    HazardousWasteNotification: 'HazardousWasteNotification',
    HazardousWasteQuarterlyReport: 'HazardousWasteQuarterlyReport',
    HazardousWasteRecertification: 'HazardousWasteRecertification',
    Invoice: 'Invoice',
    NegativeDeclaration: 'NegativeDeclaration',
    Other: 'Other',
    OtherRCRA: 'OtherRCRA',
    P2Plan: 'P2Plan',
    P2Update: 'P2Update',
    Permit: 'Permit',
    Proof: 'Proof',
    RCRAAnnual: 'RCRAAnnual',
    RCRAFeePaymentOrInvoice: 'RCRAFeePaymentOrInvoice',
    RCRAManifest: 'RCRAManifest',
    RCRAUpdateNotification: 'RCRAUpdateNotification',
    Receipt: 'Receipt',
    ReferenceImage: 'ReferenceImage',
    Report: 'Report',
    RevisionOrUpdate: 'RevisionOrUpdate',
    SafeguardMeasures: 'SafeguardMeasures',
    SafetyDataSheet: 'SafetyDataSheet',
    Screenshot: 'Screenshot',
    SiteCoordinateAbbreviation: 'SiteCoordinateAbbreviation',
    SitePlan: 'SitePlan',
    SpillPreventionControlAndCountermeasurePlan: 'SpillPreventionControlAndCountermeasurePlan',
    Submission: 'Submission',
    TrainingPlan: 'TrainingPlan',
    USTDocumentation: 'USTDocumentation',
    USTMonitoringSitePlan: 'USTMonitoringSitePlan',
    USTCertificationOfFinancialResponsibility: 'USTCertificationOfFinancialResponsibility',
    USTResponsePlan: 'USTResponsePlan',
    USTOwnerOperatorWrittenAgreement: 'USTOwnerOperatorWrittenAgreement',
    USTLetterFromChiefFinancialOfficer: 'USTLetterFromChiefFinancialOfficer',
    OwnerStatementOfDesignatedUSTOperatorCompliance: 'OwnerStatementOfDesignatedUSTOperatorCompliance',
    RecyclableMaterialsReportDocumentation: 'RecyclableMaterialsReportDocumentation',
    HazardousWasteTankClosureCertificate: 'HazardousWasteTankClosureCertificate',
    AboveGroundPetroleumStorageActDocumentation: 'AboveGroundPetroleumStorageActDocumentation',
    AboveGroundSeparationContainmentAndMonitoringPlan: 'AboveGroundSeparationContainmentAndMonitoringPlan'
};
exports.ExtractionStatus = {
    NOT_ATTEMPTED: 'NOT_ATTEMPTED',
    PENDING: 'PENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};
exports.FederalRegulatoryStatus = {
    LARGE_QUANTITY_GENERATOR: 'LARGE_QUANTITY_GENERATOR',
    SMALL_QUANTITY_GENERATOR: 'SMALL_QUANTITY_GENERATOR',
    VERY_SMALL_QUANTITY_GENERATOR: 'VERY_SMALL_QUANTITY_GENERATOR',
    NOT_A_GENERATOR: 'NOT_A_GENERATOR',
    UNDETERMINED: 'UNDETERMINED',
    PENDING: 'PENDING'
};
exports.StateRegulatoryStatus = {
    LARGE_QUANTITY_GENERATOR: 'LARGE_QUANTITY_GENERATOR',
    SMALL_QUANTITY_GENERATOR: 'SMALL_QUANTITY_GENERATOR',
    VERY_SMALL_QUANTITY_GENERATOR: 'VERY_SMALL_QUANTITY_GENERATOR',
    CONDITIONALLY_EXEMPT_SMALL_QUANTITY_GENERATOR: 'CONDITIONALLY_EXEMPT_SMALL_QUANTITY_GENERATOR',
    KANSAS_SMALL_QUANTITY_GENERATOR: 'KANSAS_SMALL_QUANTITY_GENERATOR',
    MARYLAND_GENERATOR_FULLY_REGULATED: 'MARYLAND_GENERATOR_FULLY_REGULATED',
    MEDIUM_QUANTITY_GENERATOR: 'MEDIUM_QUANTITY_GENERATOR',
    TEXAS_CLASS_1_ONLY_GENERATOR: 'TEXAS_CLASS_1_ONLY_GENERATOR',
    MINI_QUANTITY_GENERATOR: 'MINI_QUANTITY_GENERATOR',
    NOT_A_GENERATOR: 'NOT_A_GENERATOR',
    PENDING: 'PENDING',
    SAME_AS_FEDERAL: 'SAME_AS_FEDERAL',
    UNDETERMINED: 'UNDETERMINED'
};
exports.FacilityStatus = {
    PLANNED: 'PLANNED',
    OPEN: 'OPEN',
    INACTIVE: 'INACTIVE',
    CLOSED: 'CLOSED'
};
exports.CollectionMode = {
    AGGREGATE: 'AGGREGATE',
    MEASUREMENT: 'MEASUREMENT'
};
exports.FeatureFlagOverride = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    INHERIT_LD_FLAG_FOR_TENANT: 'INHERIT_LD_FLAG_FOR_TENANT'
};
exports.Country = {
    USA: 'USA',
    CANADA: 'CANADA'
};
exports.ContactReportRole = {
    EPCRA_CA_OPERATOR: 'EPCRA_CA_OPERATOR',
    EPCRA_CA_OWNER: 'EPCRA_CA_OWNER',
    EPCRA_CA_PROPERTY_OWNER: 'EPCRA_CA_PROPERTY_OWNER',
    EPCRA_CA_TANK_OPERATOR: 'EPCRA_CA_TANK_OPERATOR',
    EPCRA_CA_TANK_OWNER: 'EPCRA_CA_TANK_OWNER',
    EPCRA_CHEMICAL_CARRIER: 'EPCRA_CHEMICAL_CARRIER',
    EPCRA_EMERGENCY_CONTACT: 'EPCRA_EMERGENCY_CONTACT',
    EPCRA_EMERGENCY_COORDINATOR: 'EPCRA_EMERGENCY_COORDINATOR',
    EPCRA_EMERGENCY_EQUIPMENT_CONTACT: 'EPCRA_EMERGENCY_EQUIPMENT_CONTACT',
    EPCRA_OWNER_OPERATOR: 'EPCRA_OWNER_OPERATOR',
    EPCRA_TIER_II_CONTACT: 'EPCRA_TIER_II_CONTACT',
    EPCRA_BILLING: 'EPCRA_BILLING',
    EPCRA_T2M_PARENT_COMPANY: 'EPCRA_T2M_PARENT_COMPANY',
    EPCRA_T2M_DIRECT_SITE_COMMUNICATION: 'EPCRA_T2M_DIRECT_SITE_COMMUNICATION',
    EPCRA_REGIONAL_ENVIRONMENTAL_CONTACT: 'EPCRA_REGIONAL_ENVIRONMENTAL_CONTACT',
    GENERAL: 'GENERAL',
    RCRA_AUTHORIZED_REPRESENTATIVE: 'RCRA_AUTHORIZED_REPRESENTATIVE',
    RCRA_BILLING_CONTACT: 'RCRA_BILLING_CONTACT',
    RCRA_HURRICANE_POINT_OF_CONTACT: 'RCRA_HURRICANE_POINT_OF_CONTACT',
    RCRA_OWNER: 'RCRA_OWNER',
    RCRA_OPERATOR: 'RCRA_OPERATOR',
    RCRA_REAL_PROPERTY_OWNER: 'RCRA_REAL_PROPERTY_OWNER',
    RCRA_SITE_CONTACT: 'RCRA_SITE_CONTACT',
    RCRA_SITE_MANAGER: 'RCRA_SITE_MANAGER'
};
exports.FacilityPilotProgramStatus = {
    Ready: 'Ready',
    NotReady: 'NotReady'
};
exports.LocalJurisdictionType = {
    City: 'City',
    County: 'County',
    Township: 'Township',
    FireDepartment: 'FireDepartment',
    LEPC: 'LEPC',
    Other: 'Other'
};
exports.ThresholdReason = {
    Federal: 'Federal',
    State: 'State',
    FacilityEHSTotal: 'FacilityEHSTotal'
};
exports.ThresholdResultType = {
    SECTION_302_TPQ_HIGH: 'SECTION_302_TPQ_HIGH',
    SECTION_302_TPQ_LOW: 'SECTION_302_TPQ_LOW',
    SECTION_302: 'SECTION_302',
    SECTION_312_TPQ_HIGH: 'SECTION_312_TPQ_HIGH',
    SECTION_312_TPQ_LOW: 'SECTION_312_TPQ_LOW',
    SECTION_312: 'SECTION_312',
    SECTION_302_PBB_GROUP: 'SECTION_302_PBB_GROUP',
    SECTION_312_PBB_GROUP: 'SECTION_312_PBB_GROUP',
    AZ_GILBERT: 'AZ_GILBERT',
    CA_LEPCS_ETIOLOGIC_AGENTS: 'CA_LEPCS_ETIOLOGIC_AGENTS',
    CA_LEPCS_EXPLOSIVES: 'CA_LEPCS_EXPLOSIVES',
    CA_LEPCS_HAZARDOUS_MATERIALS: 'CA_LEPCS_HAZARDOUS_MATERIALS',
    CA_LEPCS_MANUFACTURED_NANOPARTICLES: 'CA_LEPCS_MANUFACTURED_NANOPARTICLES',
    CA_LEPCS_NRC: 'CA_LEPCS_NRC',
    CA_LEPCS_TOXIC_GASES: 'CA_LEPCS_TOXIC_GASES',
    CA_LEPCS_WASTE: 'CA_LEPCS_WASTE',
    CA_LIVERMORE_PLEASANTON_ACUTE_TOXICITY_GASES: 'CA_LIVERMORE_PLEASANTON_ACUTE_TOXICITY_GASES',
    CA_LIVERMORE_PLEASANTON_FIRE_HAZARD: 'CA_LIVERMORE_PLEASANTON_FIRE_HAZARD',
    CA_ALWAYS_REPORTING: 'CA_ALWAYS_REPORTING',
    CA_STATE: 'CA_STATE',
    CA_IFC_HAZARDS: 'CA_IFC_HAZARDS',
    DE_STATE: 'DE_STATE',
    LA_STATE: 'LA_STATE',
    MD_MONTGOMERY: 'MD_MONTGOMERY',
    MO_EXPLOSIVES: 'MO_EXPLOSIVES',
    NC_COUNTY: 'NC_COUNTY',
    NC_RTK_STATE_WIDE: 'NC_RTK_STATE_WIDE',
    NJ_EHS: 'NJ_EHS',
    NV_COMBUSTIBLE_LIQUIDS: 'NV_COMBUSTIBLE_LIQUIDS',
    NV_CORROSIVE_GASES: 'NV_CORROSIVE_GASES',
    NV_CORROSIVE_LIQUIDS: 'NV_CORROSIVE_LIQUIDS',
    NV_CORROSIVE_SOLIDS: 'NV_CORROSIVE_SOLIDS',
    NV_CRYOGENIC_LIQUIDS: 'NV_CRYOGENIC_LIQUIDS',
    NV_FLAMMABLE_GASES: 'NV_FLAMMABLE_GASES',
    NV_FLAMMABLE_LIQUIDS: 'NV_FLAMMABLE_LIQUIDS',
    NV_FLAMMABLE_SOLIDS: 'NV_FLAMMABLE_SOLIDS',
    NV_HIGHLY_TOXIC: 'NV_HIGHLY_TOXIC',
    NV_ORGANIC_PEROXIDE_LIQUIDS: 'NV_ORGANIC_PEROXIDE_LIQUIDS',
    NV_ORGANIC_PEROXIDE_SOLIDS: 'NV_ORGANIC_PEROXIDE_SOLIDS',
    NV_OXIDIZING_GASES: 'NV_OXIDIZING_GASES',
    NV_OXIDIZING_LIQUIDS: 'NV_OXIDIZING_LIQUIDS',
    NV_OXIDIZING_SOLIDS: 'NV_OXIDIZING_SOLIDS',
    NV_PYROPHORIC: 'NV_PYROPHORIC',
    NV_TOXIC_GASES: 'NV_TOXIC_GASES',
    NV_TOXIC_LIQUIDS: 'NV_TOXIC_LIQUIDS',
    NV_TOXIC_SOLIDS: 'NV_TOXIC_SOLIDS',
    NV_UNSTABLE_LIQUIDS: 'NV_UNSTABLE_LIQUIDS',
    NV_UNSTABLE_SOLIDS: 'NV_UNSTABLE_SOLIDS',
    NV_WATER_REACTIVE_LIQUIDS: 'NV_WATER_REACTIVE_LIQUIDS',
    NV_WATER_REACTIVE_SOLIDS: 'NV_WATER_REACTIVE_SOLIDS',
    NV_GAS_STATION: 'NV_GAS_STATION',
    NV_CARBON_DIOXIDE_GAS_CUBIC_FEET: 'NV_CARBON_DIOXIDE_GAS_CUBIC_FEET',
    NV_CARBON_DIOXIDE_GAS_POUNDS: 'NV_CARBON_DIOXIDE_GAS_POUNDS',
    NY_NYC: 'NY_NYC',
    NY_NYC_CAS: 'NY_NYC_CAS',
    OR_RADIOACTIVE: 'OR_RADIOACTIVE',
    OR_STATE: 'OR_STATE',
    OR_TOXICS_EXPLOSIVES: 'OR_TOXICS_EXPLOSIVES',
    VT_CARCINOGENIC: 'VT_CARCINOGENIC',
    VT_EXPLOSIVES: 'VT_EXPLOSIVES',
    VT_STATE: 'VT_STATE',
    AK_DOT_PLACARD: 'AK_DOT_PLACARD',
    AK_COMPRESSED_GAS: 'AK_COMPRESSED_GAS',
    AK_ANCHORAGE_STANDARD: 'AK_ANCHORAGE_STANDARD',
    AK_ANCHORAGE_HAZARDOUS_WASTE: 'AK_ANCHORAGE_HAZARDOUS_WASTE',
    AK_ANCHORAGE_ACUTE_HAZARDOUS_WASTE: 'AK_ANCHORAGE_ACUTE_HAZARDOUS_WASTE',
    AK_ANCHORAGE_NFPA_COMPRESSED_GAS_LOW: 'AK_ANCHORAGE_NFPA_COMPRESSED_GAS_LOW',
    AK_ANCHORAGE_NFPA_COMPRESSED_GAS_HIGH: 'AK_ANCHORAGE_NFPA_COMPRESSED_GAS_HIGH',
    AK_ANCHORAGE_CONSUMER_COMMODITY: 'AK_ANCHORAGE_CONSUMER_COMMODITY'
};
exports.ThresholdResultJurisdictionType = {
    FEDERAL: 'FEDERAL',
    STATE: 'STATE',
    LOCAL: 'LOCAL'
};
exports.EchoQuarterlyHistory = {
    SIGNIFICANT_NONCOMPLIANCE: 'SIGNIFICANT_NONCOMPLIANCE',
    VIOLATION: 'VIOLATION',
    NO_VIOLATION: 'NO_VIOLATION',
    UNKNOWN: 'UNKNOWN',
    INACTIVE: 'INACTIVE'
};
exports.FacilityTypeIndicator = {
    PUBLICLY_OWNED_TREATMENT_WORKS: 'PUBLICLY_OWNED_TREATMENT_WORKS',
    NON_PUBLICLY_OWNED_TREATMENT_WORKS: 'NON_PUBLICLY_OWNED_TREATMENT_WORKS',
    FEDERAL_FACILITY: 'FEDERAL_FACILITY'
};
exports.FacilityTypeCode = {
    COUNTY_GOVERNMENT: 'COUNTY_GOVERNMENT',
    CORPORATION: 'CORPORATION',
    MUNICIPALITY: 'MUNICIPALITY',
    DISTRICT: 'DISTRICT',
    FEDERAL_FACILITY: 'FEDERAL_FACILITY',
    GOVERNMENT_OWNED_CONTRACTOR_OPERATED: 'GOVERNMENT_OWNED_CONTRACTOR_OPERATED',
    INDIVIDUAL: 'INDIVIDUAL',
    MUNICIPAL_OR_WATER_DISTRICT: 'MUNICIPAL_OR_WATER_DISTRICT',
    MIXED_OWNERSHIP: 'MIXED_OWNERSHIP',
    NON_GOVERNMENT: 'NON_GOVERNMENT',
    PRIVATELY_OWNED_FACILITY: 'PRIVATELY_OWNED_FACILITY',
    SCHOOL_DISTRICT: 'SCHOOL_DISTRICT',
    STATE_GOVERNMENT: 'STATE_GOVERNMENT',
    TRIBAL_GOVERNMENT: 'TRIBAL_GOVERNMENT',
    UNKNOWN: 'UNKNOWN'
};
exports.MajorMinorStatusFlag = {
    MAJOR: 'MAJOR',
    NON_MAJOR: 'NON_MAJOR'
};
exports.PermitStatusCode = {
    EFFECTIVE: 'EFFECTIVE',
    ADMINISTRATIVELY_CONTINUED: 'ADMINISTRATIVELY_CONTINUED',
    EXPIRED: 'EXPIRED',
    NOT_NEEDED: 'NOT_NEEDED',
    PENDING: 'PENDING',
    RETIRED: 'RETIRED',
    TERMINATED: 'TERMINATED'
};
exports.PermitTypeCode = {
    NPDES_INDIVIDUAL_PERMIT: 'NPDES_INDIVIDUAL_PERMIT',
    NPDES_MASTER_GENERAL_PERMIT: 'NPDES_MASTER_GENERAL_PERMIT',
    GENERAL_PERMIT_COVERED_FACILITY: 'GENERAL_PERMIT_COVERED_FACILITY',
    STATE_ISSUED_MASTER_GENERAL_PERMIT_NON_NPDES: 'STATE_ISSUED_MASTER_GENERAL_PERMIT_NON_NPDES',
    INDIVIDUAL_IU_PERMIT_NON_NPDES: 'INDIVIDUAL_IU_PERMIT_NON_NPDES',
    INDIVIDUAL_STATE_ISSUED_PERMIT_NON_NPDES: 'INDIVIDUAL_STATE_ISSUED_PERMIT_NON_NPDES',
    ASSOCIATED_PERMIT_RECORD: 'ASSOCIATED_PERMIT_RECORD',
    UNPERMITTED_FACILITY: 'UNPERMITTED_FACILITY'
};
exports.AgencyTypeCode = {
    STATE: 'STATE',
    MUNICIPAL: 'MUNICIPAL',
    COUNTY: 'COUNTY',
    REGIONAL: 'REGIONAL',
    US_EPA: 'US_EPA',
    EPA_CONTRACTOR: 'EPA_CONTRACTOR',
    OTHER_EPA: 'OTHER_EPA',
    INTERSTATE: 'INTERSTATE',
    LOCAL: 'LOCAL',
    OTHER_FEDERAL: 'OTHER_FEDERAL',
    STATE_CONTRACTOR: 'STATE_CONTRACTOR',
    OTHER_STATE: 'OTHER_STATE',
    TRIBAL: 'TRIBAL',
    UNKNOWN_FROM_CONVERSION: 'UNKNOWN_FROM_CONVERSION',
    SENIOR_ENVIRONMENTAL_EMPLOYMENT_SEE_INSPECTOR: 'SENIOR_ENVIRONMENTAL_EMPLOYMENT_SEE_INSPECTOR',
    OTHER: 'OTHER',
    CONTRACTOR: 'CONTRACTOR'
};
exports.PretreatmentIndicatorCode = {
    COVERED: 'COVERED',
    EPA: 'EPA',
    REQUIRED_AND_DEVELOPING: 'REQUIRED_AND_DEVELOPING',
    STATE: 'STATE',
    APPROVED: 'APPROVED'
};
exports.HlrncCode = {
    SNC_COMPLIANCE_PERMIT_SCHEDULE_VIOLATIONS: 'SNC_COMPLIANCE_PERMIT_SCHEDULE_VIOLATIONS',
    SNC_EFFLUENT_MONTHLY_AVERAGE_LIMIT: 'SNC_EFFLUENT_MONTHLY_AVERAGE_LIMIT',
    SNC_EFFLUENT_NON_MONTHLY_AVERAGE_LIMIT: 'SNC_EFFLUENT_NON_MONTHLY_AVERAGE_LIMIT',
    SNC_COMPLIANCE_PERMIT_SCHEDULE_REPORTING: 'SNC_COMPLIANCE_PERMIT_SCHEDULE_REPORTING',
    SNC_FAILURE_TO_REPORT_DMR_NOT_RECEIVED: 'SNC_FAILURE_TO_REPORT_DMR_NOT_RECEIVED',
    FAILURE_TO_REPORT_DMR_NOT_RECEIVED: 'FAILURE_TO_REPORT_DMR_NOT_RECEIVED',
    REPORTABLE_NONCOMPLIANCE: 'REPORTABLE_NONCOMPLIANCE',
    RESOLVED_PENDING: 'RESOLVED_PENDING',
    RESOLVED_PENDING_MANUAL: 'RESOLVED_PENDING_MANUAL',
    RESOLVED: 'RESOLVED',
    NON_RNC_VIOLATIONS: 'NON_RNC_VIOLATIONS',
    UNDETERMINED: 'UNDETERMINED'
};
exports.RcraInfoSourceType = {
    PART_A: 'PART_A',
    REPORT_UPDATE_WITH_NOTIFICATION: 'REPORT_UPDATE_WITH_NOTIFICATION',
    DEACTIVATION: 'DEACTIVATION',
    EMERGENCY: 'EMERGENCY',
    IMPLEMENTER: 'IMPLEMENTER',
    ELECTRONIC_MANIFEST_BROKER: 'ELECTRONIC_MANIFEST_BROKER',
    NOTIFICATION: 'NOTIFICATION',
    REPORT: 'REPORT',
    TEMPORARY: 'TEMPORARY'
};
exports.RcraInfoNonNotifier = {
    NON_NOTIFIER_DETERMINED_TO_BE_EXEMPT: 'NON_NOTIFIER_DETERMINED_TO_BE_EXEMPT',
    FORMER_NON_NOTIFIER: 'FORMER_NON_NOTIFIER',
    NON_NOTIFIER: 'NON_NOTIFIER'
};
exports.RcraInfoAccessibility = {
    SITE_IN_BANKRUPTCY: 'SITE_IN_BANKRUPTCY',
    RESPONSIBILITIES_TRANSFERRED_TO_CERCLA: 'RESPONSIBILITIES_TRANSFERRED_TO_CERCLA',
    RESPONSIBLE_PARTIES_HAVE_FLED_THE_COUNTRY: 'RESPONSIBLE_PARTIES_HAVE_FLED_THE_COUNTRY',
    SITE_IN_LITIGATION: 'SITE_IN_LITIGATION'
};
exports.RcraInfoLandType = {
    COUNTY: 'COUNTY',
    DISTRICT: 'DISTRICT',
    FEDERAL: 'FEDERAL',
    TRIBAL: 'TRIBAL',
    MUNICIPAL: 'MUNICIPAL',
    OTHER: 'OTHER',
    PRIVATE: 'PRIVATE',
    STATE: 'STATE'
};
exports.RcraInfoFederalWasteGeneratorStatus = {
    LARGE_QUANTITY_GENERATOR: 'LARGE_QUANTITY_GENERATOR',
    SMALL_QUANTITY_GENERATOR: 'SMALL_QUANTITY_GENERATOR',
    VERY_SMALL_QUANTITY_GENERATOR: 'VERY_SMALL_QUANTITY_GENERATOR',
    NOT_A_GENERATOR: 'NOT_A_GENERATOR',
    PENDING: 'PENDING',
    UNDETERMINED: 'UNDETERMINED'
};
exports.RcraInfoDataOrigin = {
    RCRAINFO_INDUSTRY_APPLICATION: 'RCRAINFO_INDUSTRY_APPLICATION',
    RCRAINFO_BR_LOAD_UTILITY: 'RCRAINFO_BR_LOAD_UTILITY',
    DATA_ENTRY: 'DATA_ENTRY',
    EMERGENCY: 'EMERGENCY',
    EMANIFEST: 'EMANIFEST',
    MANUAL_LOAD: 'MANUAL_LOAD',
    MYRCRAID: 'MYRCRAID',
    TRANSLATION: 'TRANSLATION',
    UTILITY: 'UTILITY'
};
exports.RcraInfoOwnerOperatorIndicator = {
    CURRENT_OWNER: 'CURRENT_OWNER',
    CURRENT_OPERATOR: 'CURRENT_OPERATOR',
    PREVIOUS_OWNER: 'PREVIOUS_OWNER',
    PREVIOUS_OPERATOR: 'PREVIOUS_OPERATOR'
};
exports.WasteManifestSource = {
    eManifest: 'eManifest',
    Vendor: 'Vendor'
};
exports.WasteManifestIngestSource = {
    BrowserAutomation: 'BrowserAutomation',
    CSVImport: 'CSVImport',
    Public: 'Public',
    RCRAInfoAPI: 'RCRAInfoAPI'
};
exports.JobTask = {
    ASMARK_INGEST: 'ASMARK_INGEST',
    DATA_PIPELINE: 'DATA_PIPELINE',
    DEMO_DATA: 'DEMO_DATA',
    EMAIL_DIGESTS: 'EMAIL_DIGESTS',
    FILE_EXTRACTION: 'FILE_EXTRACTION',
    GENERATE_PDF: 'GENERATE_PDF',
    GENERATE_PDF_ECS: 'GENERATE_PDF_ECS',
    INSIGHTS_CONNECTOR: 'INSIGHTS_CONNECTOR',
    SEND_CHECK: 'SEND_CHECK',
    STAFF_REPORT: 'STAFF_REPORT',
    PROCESS_MANIFESTS: 'PROCESS_MANIFESTS',
    WEB_AUTOMATION: 'WEB_AUTOMATION',
    CHEMICAL_AGGREGATION: 'CHEMICAL_AGGREGATION',
    PROMOTE_DRAFT_REPORT: 'PROMOTE_DRAFT_REPORT',
    ONE_SCHEMA_FILE_UPLOAD: 'ONE_SCHEMA_FILE_UPLOAD',
    EXPORT_DATA: 'EXPORT_DATA',
    VALIDATE_TENANT: 'VALIDATE_TENANT',
    BULK_VERIFY_AND_SUBMIT_REPORTS: 'BULK_VERIFY_AND_SUBMIT_REPORTS',
    BULK_RESET_TIER_II_REPORTS: 'BULK_RESET_TIER_II_REPORTS',
    BULK_SEND_SUBMISSIONS_TO_REVIEWERS: 'BULK_SEND_SUBMISSIONS_TO_REVIEWERS',
    TIER_2_SUBMIT: 'TIER_2_SUBMIT',
    SIGN_PDF: 'SIGN_PDF',
    CREATE_TIER_II_DELIVERABLES: 'CREATE_TIER_II_DELIVERABLES',
    SLACK: 'SLACK',
    SEND_EMAIL: 'SEND_EMAIL',
    SEND_MAIL: 'SEND_MAIL',
    ADD_DOCUMENT: 'ADD_DOCUMENT',
    CREATE_TIER_II_DELIVERABLES_LAMBDA: 'CREATE_TIER_II_DELIVERABLES_LAMBDA',
    PRESUBMISSION: 'PRESUBMISSION',
    ZIP: 'ZIP',
    E_MANIFEST_API: 'E_MANIFEST_API',
    E_MANIFEST_SITE_ACCESS: 'E_MANIFEST_SITE_ACCESS',
    DOCS_TO_SINGLE_PDF: 'DOCS_TO_SINGLE_PDF',
    DATABASE_BENCHMARK: 'DATABASE_BENCHMARK',
    ERROR_CLUSTERING: 'ERROR_CLUSTERING',
    CREATE_SUBMISSION_TASKS: 'CREATE_SUBMISSION_TASKS',
    DOWNLOAD_MISSING_BOLDSIGN_PROOF_DOCUMENTS: 'DOWNLOAD_MISSING_BOLDSIGN_PROOF_DOCUMENTS',
    DOCUMENT_AI_ENRICHMENT: 'DOCUMENT_AI_ENRICHMENT',
    FACILITY_EMBEDDING: 'FACILITY_EMBEDDING',
    SUGGEST_TASKS: 'SUGGEST_TASKS',
    SALESFORCE_TENANT_SYNC: 'SALESFORCE_TENANT_SYNC'
};
exports.JobStatus = {
    QUEUED: 'QUEUED',
    DISPATCHED: 'DISPATCHED',
    PROVISIONING_ECS_TASK: 'PROVISIONING_ECS_TASK',
    RUNNING: 'RUNNING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
    FAILED_MAY_AUTO_RETRY: 'FAILED_MAY_AUTO_RETRY',
    FAILED_NEEDS_HUMAN: 'FAILED_NEEDS_HUMAN',
    FAILED_QUALITY_CONTROL_CHECK: 'FAILED_QUALITY_CONTROL_CHECK',
    FAILED_PROVISIONING_ECS_TASK: 'FAILED_PROVISIONING_ECS_TASK',
    AWAITING_MANUAL_INTERVENTION: 'AWAITING_MANUAL_INTERVENTION',
    SHOULD_CANCEL: 'SHOULD_CANCEL',
    CANCELLING: 'CANCELLING',
    CANCELLED: 'CANCELLED',
    PROMOTED: 'PROMOTED',
    SENT: 'SENT',
    PROVISIONING: 'PROVISIONING'
};
exports.WebAutomationAction = {
    acquireLock: 'acquireLock',
    closeDraftReport: 'closeDraftReport',
    collectEvidenceOfCompletion: 'collectEvidenceOfCompletion',
    downloadReport: 'downloadReport',
    deleteLock: 'deleteLock',
    eManifestCSVDownload: 'eManifestCSVDownload',
    eManifestDataDownload: 'eManifestDataDownload',
    extractChemicalDatabase: 'extractChemicalDatabase',
    extractData: 'extractData',
    extractOregonChemicals: 'extractOregonChemicals',
    extractStateIDs: 'extractStateIDs',
    extractHazardousMaterialsPermit: 'extractHazardousMaterialsPermit',
    finalizeSubmission: 'finalizeSubmission',
    getFacilitiesList: 'getFacilitiesList',
    inputData: 'inputData',
    inputDataRevision: 'inputDataRevision',
    inputDataNewlyNotReporting: 'inputDataNewlyNotReporting',
    inputDataLepc: 'inputDataLepc',
    portalSubmissionStatus: 'portalSubmissionStatus',
    rcra870012: 'rcra870012',
    rcra870013: 'rcra870013',
    rcraEvq: 'rcraEvq',
    rcraVerifyCredentials: 'rcraVerifyCredentials',
    scrapeDistrictInfo: 'scrapeDistrictInfo',
    verifyCredentials: 'verifyCredentials',
    verify870012Submission: 'verify870012Submission'
};
exports.WebAutomationCollectEvidenceOfCompletionActions = {
    completion: 'completion',
    chemicalCount: 'chemicalCount'
};
exports.JobRunsOn = {
    ECS: 'ECS',
    LAMBDA: 'LAMBDA'
};
exports.LockType = {
    BulkMirror: 'BulkMirror',
    Cohort: 'Cohort',
    Credential: 'Credential',
    FacilityForWasteManifest: 'FacilityForWasteManifest',
    Job: 'Job',
    Report: 'Report',
    WorkflowManager: 'WorkflowManager'
};
exports.OneSchemaImportStatus = {
    INITIALIZED: 'INITIALIZED',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
};
exports.OneSchemaImportProcessingMethod = {
    WEBHOOK: 'WEBHOOK',
    LAMBDA: 'LAMBDA'
};
exports.PaymentStatus = {
    AWAITING_INVOICE: 'AWAITING_INVOICE',
    PENDING: 'PENDING',
    PAID: 'PAID',
    NO_PAYMENT: 'NO_PAYMENT',
    CANCELLED: 'CANCELLED',
    VOID: 'VOID',
    FAILURE: 'FAILURE'
};
exports.PaymentMethod = {
    CHECK: 'CHECK',
    CREDIT_CARD: 'CREDIT_CARD',
    ACH: 'ACH',
    NO_PAYMENT: 'NO_PAYMENT'
};
exports.ReconciliationStatus = {
    UNRECONCILED: 'UNRECONCILED',
    RECONCILED: 'RECONCILED',
    PROBLEM: 'PROBLEM'
};
exports.TankOwnerType = {
    LOCAL_AGENCY: 'LOCAL_AGENCY',
    COUNTY_AGENCY: 'COUNTY_AGENCY',
    STATE_AGENCY: 'STATE_AGENCY',
    FEDERAL_AGENCY: 'FEDERAL_AGENCY',
    NON_GOVERNMENT: 'NON_GOVERNMENT'
};
exports.PortalType = {
    STATE: 'STATE',
    LEPC: 'LEPC',
    CITY: 'CITY',
    FEDERAL: 'FEDERAL'
};
exports.ChemicalDbRequirement = {
    EHS_ONLY: 'EHS_ONLY',
    ALL: 'ALL',
    NO: 'NO'
};
exports.Permission = {
    RouteEPCRA: 'RouteEPCRA',
    RouteRCRA: 'RouteRCRA',
    RouteFacilities: 'RouteFacilities',
    RouteCalendar: 'RouteCalendar',
    RouteContacts: 'RouteContacts',
    RouteDocuments: 'RouteDocuments',
    RouteEPCRAOverview: 'RouteEPCRAOverview',
    RouteEPCRATierII: 'RouteEPCRATierII',
    RouteEPCRAReports: 'RouteEPCRAReports',
    RouteEPCRAProducts: 'RouteEPCRAProducts',
    RouteEPCRACredentials: 'RouteEPCRACredentials',
    RouteInsights: 'RouteInsights',
    ReadOrgEventSequences: 'ReadOrgEventSequences',
    WriteOrgEventSequences: 'WriteOrgEventSequences',
    ReadAllFacility: 'ReadAllFacility',
    ReadAllFacilityMinimal: 'ReadAllFacilityMinimal',
    WriteAllFacility: 'WriteAllFacility',
    CreateFacility: 'CreateFacility',
    EditOwnFacilityPermissions: 'EditOwnFacilityPermissions',
    EditOwnFacilityPermissionsUnlimited: 'EditOwnFacilityPermissionsUnlimited',
    ReadAllUserTenant: 'ReadAllUserTenant',
    WriteAllUserTenant: 'WriteAllUserTenant',
    CreateUserTenant: 'CreateUserTenant',
    ReadUserTenantRole: 'ReadUserTenantRole',
    WriteUserTenantRole: 'WriteUserTenantRole',
    ReadRole: 'ReadRole',
    WriteRole: 'WriteRole',
    ReadPerson: 'ReadPerson',
    WritePerson: 'WritePerson',
    ReadFacilityContact: 'ReadFacilityContact',
    WriteFacilityContact: 'WriteFacilityContact',
    ReadSystemAuditLog: 'ReadSystemAuditLog',
    ReadUserActivityLog: 'ReadUserActivityLog',
    CreateDataCollectionTask: 'CreateDataCollectionTask',
    WriteDataCollectionTask: 'WriteDataCollectionTask',
    FulfillDataCollectionTask: 'FulfillDataCollectionTask',
    WriteDataCollectionTaskTemplate: 'WriteDataCollectionTaskTemplate',
    WriteAllCalendarEvent: 'WriteAllCalendarEvent',
    VerifyTierIIReport: 'VerifyTierIIReport',
    ManageReviewerRequirements: 'ManageReviewerRequirements',
    ViewCredentials: 'ViewCredentials'
};
exports.SnapshotType = {
    TIER_II_REPORT: 'TIER_II_REPORT'
};
exports.InsideOutside = {
    INSIDE: 'INSIDE',
    OUTSIDE: 'OUTSIDE'
};
exports.StorageQuadrant = {
    N: 'N',
    S: 'S',
    E: 'E',
    W: 'W',
    NE: 'NE',
    SE: 'SE',
    NW: 'NW',
    SW: 'SW',
    C: 'C',
    V: 'V'
};
exports.Pressure = {
    AMBIENT_PRESSURE: 'AMBIENT_PRESSURE',
    GREATER_THAN_AMBIENT_PRESSURE: 'GREATER_THAN_AMBIENT_PRESSURE',
    LESS_THAN_AMBIENT_PRESSURE: 'LESS_THAN_AMBIENT_PRESSURE',
    OTHER: 'OTHER'
};
exports.Temperature = {
    AMBIENT_TEMPERATURE: 'AMBIENT_TEMPERATURE',
    CRYOGENIC_CONDITIONS: 'CRYOGENIC_CONDITIONS',
    GREATER_THAN_AMBIENT_TEMPERATURE: 'GREATER_THAN_AMBIENT_TEMPERATURE',
    LESS_THAN_AMBIENT_TEMPERATURE_BUT_NOT_CRYOGENIC: 'LESS_THAN_AMBIENT_TEMPERATURE_BUT_NOT_CRYOGENIC'
};
exports.SubmissionStatus = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    ENCAMP_INITIAL_REVIEW: 'ENCAMP_INITIAL_REVIEW',
    IN_REVIEW: 'IN_REVIEW',
    PROCESSING_SUBMISSION: 'PROCESSING_SUBMISSION',
    FILING_COMPLETE: 'FILING_COMPLETE',
    NOT_REPORTING: 'NOT_REPORTING'
};
exports.RequirementStatus = {
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED'
};
exports.ReviewMode = {
    SEQUENTIAL: 'SEQUENTIAL',
    PARALLEL: 'PARALLEL'
};
exports.SignatureType = {
    NONE: 'NONE',
    DIGITAL: 'DIGITAL',
    WET_INK: 'WET_INK'
};
exports.SubmissionType = {
    WASTE_BIENNIAL: 'WASTE_BIENNIAL',
    BIENNIAL_REPORT: 'BIENNIAL_REPORT',
    AL_ANNUAL_NOTIFICATION: 'AL_ANNUAL_NOTIFICATION',
    AZ_REGISTRATION_REPORT: 'AZ_REGISTRATION_REPORT',
    AZ_GENERATION_REPORT: 'AZ_GENERATION_REPORT',
    ANNUAL_REPORT: 'ANNUAL_REPORT',
    CA_EVQ: 'CA_EVQ',
    CO_SQG_SELF_CERTIFICATION: 'CO_SQG_SELF_CERTIFICATION',
    ID_ANNUAL_REPORT: 'ID_ANNUAL_REPORT',
    IA_ANNUAL_REPORT: 'IA_ANNUAL_REPORT',
    KS_ANNUAL_REPORT: 'KS_ANNUAL_REPORT',
    ME_ANNUAL_REPORT: 'ME_ANNUAL_REPORT',
    KY_ANNUAL_REPORT: 'KY_ANNUAL_REPORT',
    KY_REGISTRATION_REPORT: 'KY_REGISTRATION_REPORT',
    MN_MPCA_LICENSE_RENEWAL: 'MN_MPCA_LICENSE_RENEWAL',
    MN_COUNTY_LICENSE_RENEWALS: 'MN_COUNTY_LICENSE_RENEWALS',
    MN_HENNEPIN_COUNTY_LICENSE_RENEWAL: 'MN_HENNEPIN_COUNTY_LICENSE_RENEWAL',
    MO_ANNUAL_REPORT: 'MO_ANNUAL_REPORT',
    MT_ANNUAL_REPORT: 'MT_ANNUAL_REPORT',
    NH_QUARTERLY_ACTIVITY_REPORT: 'NH_QUARTERLY_ACTIVITY_REPORT',
    NH_TRIENNIAL_REPORT: 'NH_TRIENNIAL_REPORT',
    OR_ANNUAL_REPORT: 'OR_ANNUAL_REPORT',
    SC_QUARTERLY_REPORT: 'SC_QUARTERLY_REPORT',
    SC_SQG_ANNUAL_NOTIFICATION: 'SC_SQG_ANNUAL_NOTIFICATION',
    TX_ANNUAL_WASTE_SUMMARY: 'TX_ANNUAL_WASTE_SUMMARY',
    WI_ANNUAL_REPORT: 'WI_ANNUAL_REPORT',
    DC_ANNUAL_REPORT: 'DC_ANNUAL_REPORT',
    AZ_P2_ANNUAL_PROGRESS_REPORT: 'AZ_P2_ANNUAL_PROGRESS_REPORT',
    MS_P2_ANNUAL_PROGRESS_REPORT: 'MS_P2_ANNUAL_PROGRESS_REPORT',
    NY_HAZARDOUS_WASTE_REDUCTION_PLAN: 'NY_HAZARDOUS_WASTE_REDUCTION_PLAN',
    TX_P2_ANNUAL_PROGRESS_REPORT: 'TX_P2_ANNUAL_PROGRESS_REPORT',
    WA_P2_ANNUAL_PROGRESS_REPORT: 'WA_P2_ANNUAL_PROGRESS_REPORT',
    GA_BIENNIAL_HAZARDOUS_WASTE_REDUCTION_PLAN: 'GA_BIENNIAL_HAZARDOUS_WASTE_REDUCTION_PLAN',
    NY_QUARTERLY_WASTE_TAXES: 'NY_QUARTERLY_WASTE_TAXES',
    WV_HW_GENERATOR_FEES: 'WV_HW_GENERATOR_FEES',
    HAZARDOUS_WASTE_NOTIFICATION: 'HAZARDOUS_WASTE_NOTIFICATION',
    FL_WASTE_NOTIFICATION: 'FL_WASTE_NOTIFICATION',
    NE_WASTE_NOTIFICATION: 'NE_WASTE_NOTIFICATION',
    TX_WASTE_NOTIFICATION: 'TX_WASTE_NOTIFICATION',
    NH_WASTE_NOTIFICATION: 'NH_WASTE_NOTIFICATION',
    CA_STATE_WASTE_NOTIFICATION: 'CA_STATE_WASTE_NOTIFICATION',
    KS_WASTE_NOTIFICATION: 'KS_WASTE_NOTIFICATION',
    KY_WASTE_NOTIFICATION: 'KY_WASTE_NOTIFICATION',
    LA_WASTE_NOTIFICATION: 'LA_WASTE_NOTIFICATION',
    MI_WASTE_NOTIFICATION: 'MI_WASTE_NOTIFICATION',
    MN_WASTE_NOTIFICATION: 'MN_WASTE_NOTIFICATION',
    MO_WASTE_NOTIFICATION: 'MO_WASTE_NOTIFICATION',
    OR_WASTE_NOTIFICATION: 'OR_WASTE_NOTIFICATION',
    PA_WASTE_NOTIFICATION: 'PA_WASTE_NOTIFICATION',
    TN_WASTE_NOTIFICATION: 'TN_WASTE_NOTIFICATION',
    OTHER: 'OTHER'
};
exports.SubmissionMethod = {
    RCRAINFO_BIENNIAL_REPORTING_MODULE: 'RCRAINFO_BIENNIAL_REPORTING_MODULE',
    RCRAINFO_MYRCRAID_MODULE: 'RCRAINFO_MYRCRAID_MODULE',
    RCRAINFO_ANNUAL_REPORTING_MODULE: 'RCRAINFO_ANNUAL_REPORTING_MODULE',
    AZ_MYDEQ_PORTAL: 'AZ_MYDEQ_PORTAL',
    CA_EVQ_MODULE: 'CA_EVQ_MODULE',
    CO_SELF_CERT_PORTAL: 'CO_SELF_CERT_PORTAL',
    ID_PORTAL: 'ID_PORTAL',
    KS_KEIMS_PORTAL: 'KS_KEIMS_PORTAL',
    KY_GATEWAY_PORTAL: 'KY_GATEWAY_PORTAL',
    MPCA_E_SERVICES: 'MPCA_E_SERVICES',
    COUNTY_PDFS_OR_PORTALS: 'COUNTY_PDFS_OR_PORTALS',
    HENNEPIN_HAZWASTE_PORTAL: 'HENNEPIN_HAZWASTE_PORTAL',
    MO_MOGEMS: 'MO_MOGEMS',
    OR_PORTAL: 'OR_PORTAL',
    TX_STEERS_PORTAL: 'TX_STEERS_PORTAL',
    WI_DNR_SWITCHBOARD: 'WI_DNR_SWITCHBOARD',
    DC_SQG_SELF_CERTIFICATION_PORTAL: 'DC_SQG_SELF_CERTIFICATION_PORTAL',
    WA_SAWS_TURBOPLAN: 'WA_SAWS_TURBOPLAN',
    PAPER_FORM: 'PAPER_FORM'
};
exports.SubmissionEncampStatus = {
    BLOCKED: 'BLOCKED',
    NEEDS_CORRECTION: 'NEEDS_CORRECTION',
    REJECTED: 'REJECTED',
    RESOLVING: 'RESOLVING',
    PROCESSING: 'PROCESSING'
};
exports.SubmissionSource = {
    USER: 'USER',
    SYSTEM: 'SYSTEM'
};
exports.DocumentSource = {
    CUSTOMER: 'CUSTOMER',
    TPM: 'TPM'
};
exports.SubmissionDocumentType = {
    SUBMISSION: 'SUBMISSION',
    SIGNED_SUBMISSION: 'SIGNED_SUBMISSION',
    REJECTED_SUBMISSION: 'REJECTED_SUBMISSION',
    ATTACHMENT: 'ATTACHMENT'
};
exports.ReviewerStatus = {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
};
exports.SignatureStatus = {
    NONE: 'NONE',
    NOT_COMPLETED: 'NOT_COMPLETED',
    COMPLETED: 'COMPLETED',
    DECLINED: 'DECLINED',
    REVOKED: 'REVOKED',
    EXPIRED: 'EXPIRED',
    SENT: 'SENT'
};
exports.TagType = {
    Document: 'Document',
    Facility: 'Facility',
    Task: 'Task',
    Waste: 'Waste',
    Workflow: 'Workflow'
};
exports.TagIcon = {
    BADGE_CHECK: 'BADGE_CHECK',
    FOLDER_OPEN: 'FOLDER_OPEN',
    RADIATION_ALT: 'RADIATION_ALT',
    RECYCLE: 'RECYCLE',
    TRASH: 'TRASH',
    USER_HARD_HAT: 'USER_HARD_HAT',
    WATER: 'WATER',
    WIND: 'WIND'
};
exports.Frequency = {
    ONCE: 'ONCE',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY'
};
exports.TaskKind = {
    TEMPLATE: 'TEMPLATE',
    INSTANCE: 'INSTANCE',
    STANDALONE: 'STANDALONE'
};
exports.TenantContactType = {
    CSM: 'CSM',
    WASTE_MANAGER: 'WASTE_MANAGER',
    DATA_MANAGER: 'DATA_MANAGER',
    CUSTOMER_POC: 'CUSTOMER_POC',
    ACCOUNT_MANAGER: 'ACCOUNT_MANAGER'
};
exports.TierIIReportKind = {
    ANNUAL: 'ANNUAL',
    INITIAL: 'INITIAL',
    NEWLY_NOT_REPORTING: 'NEWLY_NOT_REPORTING',
    REVISION: 'REVISION',
    UPDATE: 'UPDATE'
};
exports.TierIIReportOrgStatus = {
    ASSIGNED: 'ASSIGNED',
    IN_PROGRESS: 'IN_PROGRESS',
    IN_REVIEW: 'IN_REVIEW',
    NOT_REPORTING: 'NOT_REPORTING',
    NOT_STARTED: 'NOT_STARTED',
    VERIFIED: 'VERIFIED'
};
exports.TierIIReportEncampStatus = {
    AWAITING_VERIFICATION: 'AWAITING_VERIFICATION',
    NOT_REPORTING: 'NOT_REPORTING',
    PROCESSING: 'PROCESSING',
    FILING_COMPLETE: 'FILING_COMPLETE'
};
exports.TierIIReportStep = {
    CHEMICALS: 'CHEMICALS',
    CHEMICAL_SUMMARY: 'CHEMICAL_SUMMARY',
    CONTACTS: 'CONTACTS',
    DOCUMENTS: 'DOCUMENTS',
    FACILITY: 'FACILITY',
    OTHER_CHEMICALS: 'OTHER_CHEMICALS',
    PRODUCTS: 'PRODUCTS',
    REGULATORY: 'REGULATORY',
    REPORT_OVERVIEW: 'REPORT_OVERVIEW',
    REVIEW: 'REVIEW',
    STATE_INFORMATION: 'STATE_INFORMATION',
    VERIFY_AND_SUBMIT: 'VERIFY_AND_SUBMIT'
};
exports.TierIIReportCAStep = {
    APSAFacilityInformation: 'APSAFacilityInformation',
    AboveGroundSeparationContainmentAndMonitoringPlan: 'AboveGroundSeparationContainmentAndMonitoringPlan',
    AbovegroundPetroleumStorageActDocumentation: 'AbovegroundPetroleumStorageActDocumentation',
    EmergencyResponseContingencyPlan: 'EmergencyResponseContingencyPlan',
    EmployeeTrainingPlan: 'EmployeeTrainingPlan',
    FacilityInformation: 'FacilityInformation',
    HazardousWasteTankClosureCertificate: 'HazardousWasteTankClosureCertificate',
    OwnerStatementOfDesignatedUSTOperatorCompliance: 'OwnerStatementOfDesignatedUSTOperatorCompliance',
    RecyclableMaterialsReportDocumentation: 'RecyclableMaterialsReportDocumentation',
    SitePlan: 'SitePlan',
    USTCertificationOfFinancialResponsibility: 'USTCertificationOfFinancialResponsibility',
    USTCertificationsOfInstallationModification: 'USTCertificationsOfInstallationModification',
    USTFacilityOperatingPermitApplication: 'USTFacilityOperatingPermitApplication',
    USTLetterFromChiefFinancialOfficer: 'USTLetterFromChiefFinancialOfficer',
    USTMonitoringSitePlan: 'USTMonitoringSitePlan',
    USTOwnerOperatorWrittenAgreement: 'USTOwnerOperatorWrittenAgreement',
    USTResponsePlan: 'USTResponsePlan'
};
exports.TierIIReportFiledBy = {
    ENCAMP: 'ENCAMP',
    OTHER: 'OTHER'
};
exports.AssignmentType = {
    ASSIGNEE: 'ASSIGNEE',
    REVIEWER: 'REVIEWER'
};
exports.StatusType = {
    encampStatus: 'encampStatus',
    organizationStatus: 'organizationStatus'
};
exports.TierIIReportUstStep = {
    TankInformation: 'TankInformation',
    TankMonitoringPlan: 'TankMonitoringPlan'
};
exports.UserType = {
    STAFF_ADMIN: 'STAFF_ADMIN',
    STAFF_EMPLOYEE: 'STAFF_EMPLOYEE',
    STAFF_TEMP: 'STAFF_TEMP',
    CUSTOMER: 'CUSTOMER'
};
exports.UserStatus = {
    NOT_INVITED: 'NOT_INVITED',
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    DISABLED: 'DISABLED'
};
exports.EManifestWasteUnit = {
    G: 'G',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    P: 'P',
    T: 'T',
    Y: 'Y'
};
exports.WasteClassificationLegacy = {
    RCRA_ACUTELY_HAZARDOUS: 'RCRA_ACUTELY_HAZARDOUS',
    RCRA_HAZARDOUS: 'RCRA_HAZARDOUS',
    STATE_REGULATED: 'STATE_REGULATED',
    UNIVERSAL: 'UNIVERSAL',
    PHARMACEUTICAL: 'PHARMACEUTICAL',
    NONHAZARDOUS: 'NONHAZARDOUS'
};
exports.StateWasteClassification = {
    HAZARDOUS: 'HAZARDOUS',
    NONHAZARDOUS: 'NONHAZARDOUS',
    ACUTELY_HAZARDOUS: 'ACUTELY_HAZARDOUS'
};
exports.WasteClassification = {
    RCRA_ACUTELY_HAZARDOUS: 'RCRA_ACUTELY_HAZARDOUS',
    RCRA_HAZARDOUS: 'RCRA_HAZARDOUS',
    STATE_REGULATED: 'STATE_REGULATED',
    NONHAZARDOUS: 'NONHAZARDOUS'
};
exports.ActivityType = {
    AddDocument: 'AddDocument',
    CollectEvidence: 'CollectEvidence',
    CollectEvidenceOfCompletion: 'CollectEvidenceOfCompletion',
    CreatePdf: 'CreatePdf',
    CreateZip: 'CreateZip',
    DistributeCohortDocuments: 'DistributeCohortDocuments',
    Error: 'Error',
    FillPdf: 'FillPdf',
    Geppetto: 'Geppetto',
    GenerateCustomerDeliverables: 'GenerateCustomerDeliverables',
    Lob: 'Lob',
    Presubmission: 'Presubmission',
    SendEmail: 'SendEmail',
    SendSupplementalAgencyCommunication: 'SendSupplementalAgencyCommunication',
    SignReportPages: 'SignReportPages',
    Staff: 'Staff',
    Tier2Submit: 'Tier2Submit',
    Tier2SubmitValidation: 'Tier2SubmitValidation',
    ValidateCohort: 'ValidateCohort',
    WaitForAllAltIdReports: 'WaitForAllAltIdReports',
    WaitForAllCNReports: 'WaitForAllCNReports',
    WaitForAllCredentialReports: 'WaitForAllCredentialReports',
    WaitForAllStateReports: 'WaitForAllStateReports',
    WaitForAllFD: 'WaitForAllFD',
    WaitForAllLEPC: 'WaitForAllLEPC',
    InitializeCohorts: 'InitializeCohorts',
    WaitForCohorts: 'WaitForCohorts',
    ValidateCohortMembership: 'ValidateCohortMembership'
};
exports.ExecutionPlanType = {
    Human: 'Human',
    Automation: 'Automation'
};
exports.ActivityStatus = {
    NotStarted: 'NotStarted',
    InProgress: 'InProgress',
    Error: 'Error',
    StaffCompleted: 'StaffCompleted',
    Completed: 'Completed',
    Canceled: 'Canceled',
    Queued: 'Queued'
};
exports.Tier2SubmitValidationStatus = {
    Valid: 'Valid',
    Invalid: 'Invalid',
    HasWarnings: 'HasWarnings',
    PendingValidation: 'PendingValidation',
    ServiceError: 'ServiceError'
};
exports.ActivityUserInputType = {
    Boolean: 'Boolean',
    Number: 'Number'
};
exports.WorkflowType = {
    TierIIReportSubmission: 'TierIIReportSubmission',
    Cohort: 'Cohort'
};
exports.WorkflowStatus = {
    NotStarted: 'NotStarted',
    InProgress: 'InProgress',
    Paused: 'Paused',
    Error: 'Error',
    Completed: 'Completed',
    Canceled: 'Canceled'
};
exports.WorkflowManagerConfigType = {
    ALLOW_ENVIRONMENT: 'ALLOW_ENVIRONMENT',
    ALLOW_STATE: 'ALLOW_STATE',
    ALLOW_STATE_REVISION: 'ALLOW_STATE_REVISION',
    ALLOW_STATE_NEWLY_NOT_REPORTING: 'ALLOW_STATE_NEWLY_NOT_REPORTING',
    ALLOW_FACILITY_NEWLY_NOT_REPORTING: 'ALLOW_FACILITY_NEWLY_NOT_REPORTING',
    ALLOW_FACILITY: 'ALLOW_FACILITY',
    ALLOW_FACILITY_REVISION: 'ALLOW_FACILITY_REVISION',
    DENY_TENANT: 'DENY_TENANT',
    DENY_TENANT_REVISION: 'DENY_TENANT_REVISION',
    DENY_TENANT_NEWLY_NOT_REPORTING: 'DENY_TENANT_NEWLY_NOT_REPORTING',
    DENY_TENANT_FOR_STATE: 'DENY_TENANT_FOR_STATE',
    DENY_TENANT_FOR_STATE_REVISION: 'DENY_TENANT_FOR_STATE_REVISION',
    DENY_TENANT_FOR_STATE_NEWLY_NOT_REPORTING: 'DENY_TENANT_FOR_STATE_NEWLY_NOT_REPORTING',
    DENY_FACILITY: 'DENY_FACILITY',
    DENY_FACILITY_REVISION: 'DENY_FACILITY_REVISION',
    DENY_FACILITY_NEWLY_NOT_REPORTING: 'DENY_FACILITY_NEWLY_NOT_REPORTING',
    STATE_BYPASS_VALIDATION: 'STATE_BYPASS_VALIDATION',
    FACILITY_BYPASS_VALIDATION: 'FACILITY_BYPASS_VALIDATION',
    FORCE_REPORT_TYPE_FOR_SUBMISSION: 'FORCE_REPORT_TYPE_FOR_SUBMISSION',
    TESTING_FAILURE_RATE: 'TESTING_FAILURE_RATE',
    WEB_AUTOMATION_STATE_OVERRIDE_USE_AA: 'WEB_AUTOMATION_STATE_OVERRIDE_USE_AA',
    DENY_LOB_MAIL_TO_SERC: 'DENY_LOB_MAIL_TO_SERC',
    VERSION: 'VERSION',
    SCHEDULER_WORK_INTERVAL_SLEEP_TIME_MS: 'SCHEDULER_WORK_INTERVAL_SLEEP_TIME_MS',
    SCHEDULER_CONSUMER_INTERVAL_SLEEP_TIME_MS: 'SCHEDULER_CONSUMER_INTERVAL_SLEEP_TIME_MS',
    SCHEDULER_RUNNING_POOL_MAX_CAPACITY: 'SCHEDULER_RUNNING_POOL_MAX_CAPACITY',
    SCHEDULER_DB_ACU_CUTOFF_PERCENT: 'SCHEDULER_DB_ACU_CUTOFF_PERCENT',
    SCHEDULER_ERROR_RATE_CUTOFF_PERCENT: 'SCHEDULER_ERROR_RATE_CUTOFF_PERCENT',
    SCHEDULER_CAPACITY_WAIT_DELAY_MS: 'SCHEDULER_CAPACITY_WAIT_DELAY_MS',
    SCHEDULER_LONG_RUNNING_THRESHOLD_MS: 'SCHEDULER_LONG_RUNNING_THRESHOLD_MS',
    SCHEDULER_METRICS_CACHE_DURATION_MS: 'SCHEDULER_METRICS_CACHE_DURATION_MS',
    SCHEDULER_LAMBDA_METRICS_WINDOW_MS: 'SCHEDULER_LAMBDA_METRICS_WINDOW_MS',
    SCHEDULER_MIN_ERROR_SAMPLES: 'SCHEDULER_MIN_ERROR_SAMPLES',
    SCHEDULER_COHORT_CLOSE_INTERVAL_MS: 'SCHEDULER_COHORT_CLOSE_INTERVAL_MS',
    ERROR_CLUSTERING_DISTANCE_THRESHOLD: 'ERROR_CLUSTERING_DISTANCE_THRESHOLD',
    ALLOWED_RESET_REPORT_EMAILS: 'ALLOWED_RESET_REPORT_EMAILS',
    ALLOWED_WORKFLOW_CONFIG_MANAGER_EMAILS: 'ALLOWED_WORKFLOW_CONFIG_MANAGER_EMAILS'
};
exports.ProgramArea = {
    EPCRA: 'EPCRA',
    RCRA: 'RCRA'
};
//# sourceMappingURL=enums.js.map